export default "__VITE_ASSET__BUgr$Ap9__"